<div class="screen-loadinganimation">
	<div class="title">{{title | uppercase}}</div>
	<div class="loadinganimation-center">
		<div *ngIf="dashIcon" class="icon {{dashIcon}}"></div>
	</div>	<div class="blocks">
		<div *ngFor="let block of [1,2,3,4,5,6,7,8,9,10,11,12]" class="block block-{{block}}"></div>
	</div>
	<div class="text text-1">{{getText(0)}}</div>
	<div class="text text-2">{{getText(1)}}</div>
</div>

